import React from 'react'
import Background from './Background'

function BG() {
    return (
        <div
            className="background"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: -1,
                filter: 'opacity(15%)',
                // filter: 'blur(8px)',
            }}>
            <Background />
        </div>
    )
}

export default BG